import types from './types'

const getIpAddressRequest = payload => ({
  type: types.GET_IP_ADDRESS_REQUEST,
  payload,
})

const getIpAddressSuccess = payload => ({
  type: types.GET_IP_ADDRESS_SUCCESS,
  payload,
})

const getIpAddressFailure = () => ({
  type: types.GET_IP_ADDRESS_FAILURE,
})

const postMessageRequest = payload => ({
  type: types.POST_MESSAGE_REQUEST,
  payload,
})

const postMessageSuccess = payload => ({
  type: types.POST_MESSAGE_SUCCESS,
  payload,
})

const postMessageFailure = () => ({
  type: types.POST_MESSAGE_FAILURE,
})

const postQuickReplyRequest = payload => ({
  type: types.POST_QUICKREPLY_REQUEST,
  payload,
})

const postQuickReplySuccess = payload => ({
  type: types.POST_QUICKREPLY_SUCCESS,
  payload,
})

const postQuickReplyFailure = () => ({
  type: types.POST_QUICKREPLY_FAILURE,
})


const receiveData = payload => ({
  type: types.RECEIVE_DATA,
  payload,
})

const storeBotData = payload => ({
  type: types.STORE_BOT_DATA,
  payload,
})

const setEmotion = payload => ({
  type: types.SET_EMOTION,
  payload,
})

export default {
  getIpAddressRequest,
  getIpAddressSuccess,
  getIpAddressFailure,

  postMessageRequest,
  postMessageSuccess,
  postMessageFailure,

  postQuickReplyRequest,
  postQuickReplySuccess,
  postQuickReplyFailure,

  receiveData,
  storeBotData,
  setEmotion,
}



// WEBPACK FOOTER //
// ./src/redux/actions.js